var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoNegativo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11432",
    "data-name": "Group 11432",
    transform: "translate(-306.999 -417.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6579",
    "data-name": "Group 6579",
    transform: "translate(306.262 417.262)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 51,
    cy: 51,
    r: 51,
    transform: "translate(0.737 0.737)",
    fill: "#9eaced"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5699",
    "data-name": "Path 5699",
    d: "M885.883,787.331l-6.6-6.6c-1.575-1.575-3.161-3.137-4.719-4.728a5.593,5.593,0,0,1-1.489-5.851,5.738,5.738,0,0,1,4.641-4.184,5.58,5.58,0,0,1,5.233,1.632q5.495,5.473,10.971,10.965c.107.107.194.236.328.4.185-.178.325-.308.459-.442l10.937-10.933a5.933,5.933,0,0,1,8.552,8.218c-2.56,2.657-5.2,5.234-7.814,7.844-1.217,1.217-2.438,2.43-3.771,3.759a5.479,5.479,0,0,1,.609.457q5.393,5.38,10.775,10.772a5.794,5.794,0,0,1,1.137,6.864,5.916,5.916,0,0,1-9.507,1.57q-5.454-5.482-10.93-10.941c-.118-.119-.219-.254-.35-.408-.139.123-.242.2-.334.3q-5.483,5.484-10.968,10.965a5.59,5.59,0,0,1-6.382,1.4,5.744,5.744,0,0,1-3.837-5.455,5.622,5.622,0,0,1,1.776-4.313q5.5-5.5,11-10.995C885.687,787.543,885.767,787.454,885.883,787.331Z",
    transform: "translate(-535.793 -317.852)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNegativo);
export default __webpack_public_path__ + "static/media/ICO-NEGATIVO.ada94f1d0a38ff3899a6372294037936.svg";
export { ForwardRef as ReactComponent };